/**
 * Enum encapsulating various visibility states that a group can have
 */ export var GroupVisibilityMode = /*#__PURE__*/ function(GroupVisibilityMode) {
    /**
     * Group is visible to everyone
     */ GroupVisibilityMode["Public"] = "public";
    /**
     * Group is only visible to members of the group but membership is queryable.
     */ GroupVisibilityMode["Private"] = "private";
    /**
     * Group is only visible to members of the group but membership is non-queryable.
     */ GroupVisibilityMode["HiddenMembership"] = "hiddenMembership";
    return GroupVisibilityMode;
}({});
